import { Component, Input, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatRadioModule } from '@angular/material/radio';
import { MatIconModule } from '@angular/material/icon';
import { PaymentMethodModel } from '../../../../customer/customer.model';
import { BulkPaymentMatch } from '../../../models/bulk-payment.model';

@Component({
  selector: 'app-payment-method-selector-modal',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    MatFormFieldModule,
    MatRadioModule,
    MatIconModule
  ],
  templateUrl: './payment-method-selector-modal.component.html'
})
export class PaymentMethodSelectorModalComponent implements OnInit {
  @Input() data: any;

  selectedPaymentMethod: PaymentMethodModel | null = null;
  cardPaymentMethods: PaymentMethodModel[] = [];
  achPaymentMethods: PaymentMethodModel[] = [];

  ngOnInit(): void {
    // The modal service nests the data under data.data
    const paymentMethods = this.data?.data?.paymentMethods || [];
    
    // Separate payment methods by type
    this.cardPaymentMethods = paymentMethods.filter((pm: PaymentMethodModel) => pm.accountType !== 'ACH');
    this.achPaymentMethods = paymentMethods.filter((pm: PaymentMethodModel) => pm.accountType === 'ACH');

    // Auto-select default payment method if available
    const defaultMethod = paymentMethods.find((pm: PaymentMethodModel) => pm.isDefault);
    if (defaultMethod) {
      this.selectedPaymentMethod = defaultMethod;
    }
  }

  getPaymentMethodDisplay(method: PaymentMethodModel): string {
    if (method.accountType === 'ACH') {
      return `ACH ****${method.account?.slice(-4) || ''}`;
    }
    const cardType = method.cardLabel || 'Card';
    return `${cardType} ****${method.account?.slice(-4) || ''}`;
  }

  getPaymentMethodIcon(method: PaymentMethodModel): string {
    if (method.accountType === 'ACH') {
      return 'account_balance';
    }
    return 'credit_card';
  }

  isValidSelection(): boolean {
    return this.selectedPaymentMethod !== null;
  }
}

